// Added by Jonghyung Lee on 2020-09-14
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

export interface StudyStatus {
  activated: boolean
  code: number
  color: string
  created_at: string
  description?: string
  id: string
  name: string
  updated_at: string
}

interface ResGetStudyStatus {
  items: StudyStatus[]
}

export const reqGetStudyStatus = async (token: string) => {
  return await axios.get<ResGetStudyStatus>(`v1/data/${token}/config/study-statuses`)
}
